import { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "@aws-amplify/api";
import { updateLLMCustomer } from "../graphql/mutations";
import { UpdateLLMCustomerMutation } from "../API";

export async function updateLLMCustomerStatus(
  id: string,
  status: string,
): Promise<GraphQLResult<UpdateLLMCustomerMutation>> {
  return API.graphql(
    graphqlOperation(updateLLMCustomer, {
      input: {
        id: id,
        status: status,
      },
    })
  ) as Promise<GraphQLResult<UpdateLLMCustomerMutation>>;
}
